import React, { useState, useEffect, useRef } from 'react';
import RelativePortal from 'react-relative-portal';
import GithubPicker from 'react-color/lib/components/github/Github';
import SketchPicker from 'react-color/lib/components/sketch/Sketch';
import tinyColor from 'tinycolor2';
import PropTypes from 'prop-types';
import { FormInputItem } from 'blaze-form';

const FormInputColorPicker = props => {
  const { field, value, onChange = () => {}, onBlur = () => {}, ...rest } = props;
  const [displayColorPicker, setDisplayColorPicker] = useState(false);
  const [color, setColor] = useState(value);
  const inputRef = useRef(null);

  const toggleColorPicker = () => {
    setDisplayColorPicker(!displayColorPicker);
  };

  const triggerHide = event => {
    if (event.keyCode === 27) {
      // ESC
      setDisplayColorPicker(false);
    }
  };

  const handleInputChange = (name, newColor) => {
    onChange(name, newColor);
    setColor(newColor);
  };

  const handleColorChange = newColor => {
    setColor(newColor.hex);
    if (field.colors !== 'All') {
      // don't auto-close for draggable pickers
      setDisplayColorPicker(false);
    }
  };

  const handleInputBlur = fieldName => {
    const result = onBlur(fieldName);

    if (result && result.displayValue !== undefined) {
      setColor(result.displayValue);
    }

    return result;
  };

  useEffect(() => {
    document.addEventListener('keyup', triggerHide);

    return () => {
      document.removeEventListener('keyup', triggerHide);
    };
  }, []);

  const picker =
    field.colors === 'All' ? (
      <SketchPicker color={color} onChangeComplete={handleColorChange} onMouseUp={toggleColorPicker} />
    ) : (
      <GithubPicker onChangeComplete={handleColorChange} style={{ position: 'absolute' }} />
    );

  const containerClass = {
    'has-icon': true,
    'is-dark': tinyColor(color).isDark(),
    'is-color': true,
  };

  return (
    <FormInputItem
      containerClass={containerClass}
      value={color}
      onChange={handleInputChange}
      onBlur={handleInputBlur}
      alwaysUpdate
      ref={inputRef}
      field={field}
      {...rest}
    >
      <div className="icon-wrapper">
        <div className="color-picker" onClick={toggleColorPicker}>
          <div className="palette" style={{ backgroundColor: color }}>
            <i className="zmdi zmdi-eyedropper" />
          </div>
        </div>
        {displayColorPicker && (
          <div className="popover-form">
            <div className="cover" onClick={toggleColorPicker} />
            <RelativePortal component="div" left={0} top={0}>
              {picker}
            </RelativePortal>
          </div>
        )}
      </div>
    </FormInputItem>
  );
};

FormInputColorPicker.propTypes = {
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  field: PropTypes.object,
  value: PropTypes.string,
};

export default FormInputColorPicker;
